import { LinkTarget } from '../../../types/pdfjs-dist.type';
import { cancelable } from 'cancelable-promise';
import { PdfJsLinkService } from './pdfjs-link.service';
export class PdfJsService {
    constructor(loadPdfJsResourcesPromise, url, pages, fileSize, defaultRangeChunkSize, minRangeChunkSize, maxRangeChunkSize, eventBus) {
        this.loadPdfJsResourcesPromise = loadPdfJsResourcesPromise;
        this.url = url;
        this.pages = pages;
        this.fileSize = fileSize;
        this.defaultRangeChunkSize = defaultRangeChunkSize;
        this.minRangeChunkSize = minRangeChunkSize;
        this.maxRangeChunkSize = maxRangeChunkSize;
        this.eventBus = eventBus;
        this.pdfJsLinkService = new PdfJsLinkService(eventBus, this.pages, LinkTarget.BLANK);
        window.pdfJsService = this;
    }
    getPage(pageNumber) {
        return cancelable(new Promise((resolve, reject) => {
            this.loadPdfJs()
                .then(() => this.loadWorker())
                .then(() => this.loadDocument())
                .then(() => this.pdfJsDocument.getPage(pageNumber))
                .then(page => resolve(page))
                .catch(error => reject(error));
        }));
    }
    destroy() {
        if (this.loadPdfJsPromise) {
            this.loadPdfJsPromise.cancel();
            this.loadPdfJsPromise = null;
        }
        if (this.getDocumentTask) {
            this.getDocumentTask.destroy();
            this.getDocumentTask = null;
        }
        if (this.loadDocumentPromise) {
            this.loadDocumentPromise.cancel();
            this.loadDocumentPromise = null;
        }
        if (this.pdfJsDocument) {
            this.pdfJsDocument.cleanup();
            this.pdfJsDocument.destroy();
            this.pdfJsDocument = null;
        }
        if (this.pdfJsWorker) {
            this.pdfJsWorker.promise.catch(() => { });
            this.pdfJsWorker.destroy();
            this.pdfJsWorker = null;
        }
    }
    loadPdfJs() {
        if (this.loadPdfJsPromise) {
            return this.loadPdfJsPromise;
        }
        this.loadPdfJsPromise = cancelable(new Promise((resolve, reject) => {
            this.loadPdfJsResourcesPromise
                .then(result => {
                this.pdfjsLib = result.pdfjsLib;
                this.pdfJsDistVersionConfig = result.versionConfig;
                resolve();
            })
                .catch(reject);
        }));
        return this.loadPdfJsPromise;
    }
    loadWorker() {
        if (this.pdfJsWorker) {
            return Promise.resolve();
        }
        this.pdfJsWorker = new this.pdfjsLib.PDFWorker();
        return Promise.resolve();
    }
    loadDocument() {
        if (this.loadDocumentPromise) {
            return this.loadDocumentPromise;
        }
        this.loadDocumentPromise = cancelable(new Promise((resolve, reject) => {
            this.getDocumentTask = this.pdfjsLib.getDocument(this.getDocumentConfig());
            this.getDocumentTask.promise
                .then(pdfJsDocument => {
                this.pdfJsDocument = pdfJsDocument;
                this.pdfJsLinkService.setDocument(this.pdfJsDocument);
                resolve();
            })
                .catch(error => {
                this.loadDocumentPromise = null;
                reject();
            });
        }));
        return this.loadDocumentPromise;
    }
    getDocumentConfig() {
        const length = this.fileSize;
        const pageCount = this.pages.size;
        const rangeChunkSize = this.calculateRangeChunkSize(length, pageCount, this.minRangeChunkSize, this.maxRangeChunkSize, this.defaultRangeChunkSize);
        return {
            url: this.url,
            worker: this.pdfJsWorker,
            withCredentials: true,
            length,
            rangeChunkSize,
            disableRange: false,
            disableAutoFetch: true,
            disableStream: true,
            cMapUrl: this.pdfJsDistVersionConfig.cMapUrl,
            cMapPacked: true
        };
    }
    calculateRangeChunkSize(length, pageCount, minRangeChunkSize, maxRangeChunkSize, defaultRangeChunkSize) {
        if (length && pageCount) {
            return Math.round(Math.max(Math.min(length / pageCount, maxRangeChunkSize), minRangeChunkSize));
        }
        return defaultRangeChunkSize;
    }
}
//# sourceMappingURL=pdfjs.service.js.map